import React from "react";
import { FeedProvider, onFetchNextPageProps } from "src/context/Feed";
import { Dashboard } from "src/templates";
import { apiClient } from "src/api/apiService";
import { PageTitleSection } from "./PageTitleSection";
import ContentSectionResponsive from "./ContentSection";
import { mapRequestsToDraftTableRows, SortByEnum } from "src/components/Drafts";
import { PremiseRequest } from "src/components/Premises";
import { ActionSection } from "./ActionSection";

export const Drafts: React.FC = () => {
  const handleFetchNextPage = async ({
    searchTerm,
    page,
    sortConfig,
  }: onFetchNextPageProps) => {
    const draftsUrl = "/draft/requests";
    const response = await apiClient.get<{ requests: PremiseRequest[] }>(
      draftsUrl,
      {
        params: {
          page,
          limit: 10,
          sortDirection: sortConfig.direction,
          sortBy: sortConfig.key,
          searchTerm: searchTerm?.trim() || undefined,
        },
      }
    );
    return {
      newData: mapRequestsToDraftTableRows(response.data.requests),
      isEOL: response.data.requests.length === 0,
    };
  };

  return (
    <FeedProvider
      onFetchNextPage={handleFetchNextPage}
      initialState={{
        sortConfig: { key: SortByEnum.UPDATED, direction: "DESC" },
      }}
    >
      <Dashboard
        pageTitleSection={<PageTitleSection />}
        actionSection={<ActionSection />}
        data-id="draftsDashboard"
      >
        <ContentSectionResponsive />
      </Dashboard>
    </FeedProvider>
  );
};
